import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { createCommission } from 'bundles/apex/deals/show/store/deal/actions';
import { showSnackbar } from 'components/ui/snackbar/helper';

import { Button } from 'components/ui/button';
import ContactSelector from 'bundles/backoffice/contacts/selector';
import ManagedFormGroup from 'components/form/managed_input/form_group';
import Modal from 'components/modal';
import { requestErrors } from 'helpers/api_errors';

export function AddOutsideBrokerModal({
  createCommission,
  show,
  showQuickbooks,
  transactionSide,
  transactionSideOptions,
  onClose
}) {
  const [contact, setContact] = useState();
  const [saving, setSaving] = useState();
  const [formTransactionSide, setTransactionSide] = useState();

  function reset() {
    setContact(null);
    if (transactionSide) {
      setTransactionSide(transactionSide);
    } else if (transactionSideOptions) {
      setTransactionSide(transactionSideOptions[0][0]);
    }
  }

  async function handleSave() {
    setSaving(true);
    try {
      await createCommission({ contact, outside: true, transactionSide: formTransactionSide });
      onClose();
    } catch (errors) {
      // helpers/api rejects with the server's `errors` array when it sends one.
      showSnackbar({ text: requestErrors(errors, 'Could not add the broker.').join(' '), variant: 'danger' });
    } finally {
      setSaving(false);
    }
  }

  return (
    <Modal show={show} onHide={onClose} onShow={reset}>
      <Modal.Header closeButton>
        Add Outside Broker
      </Modal.Header>

      <Modal.Body>
        <label>Select Contact</label>
        <ContactSelector contact={contact} showQuickbooks={showQuickbooks} onChange={setContact} />

        {!transactionSide && transactionSideOptions &&
          <form className="mt-3">
            <ManagedFormGroup
              label="Transaction Side"
              name="transactionSide"
              required
              type="select"
              value={formTransactionSide}
              onValueChange={setTransactionSide}
            >
              {transactionSideOptions.map(([value, label]) => (
                <option key={value} value={value}>
                  {label}
                </option>
              ))}
            </ManagedFormGroup>
          </form>
        }
      </Modal.Body>

      <Modal.Footer>
        <Button label="Cancel" variant="ghost" onClick={onClose} />
        <Button disabled={!contact || saving} label="Add Broker" onClick={handleSave} />
      </Modal.Footer>
    </Modal>
  );
}

AddOutsideBrokerModal.propTypes = {
  createCommission: PropTypes.func.isRequired,
  show: PropTypes.bool,
  showQuickbooks: PropTypes.bool,
  transactionSide: PropTypes.string,
  transactionSideOptions: PropTypes.array,
  onClose: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  showQuickbooks: state.features.quickbooksAccountingIntegration,
  transactionSideOptions: state.options.transactionSide,
});

const mapDispatchToProps = {
  createCommission,
};

export default connect(mapStateToProps, mapDispatchToProps)(AddOutsideBrokerModal);
